import { useMutationHook, useQueryHook } from "@/hooks"
import { createReportHistory, readReportHistory } from "@/app/api/reportHistory"
import type { ReportHistoryEntry, CreateReportHistoryPayload } from "@/types/reportHistory"
import type { UseQueryOptions } from "@tanstack/react-query"
import type { ApiError } from "@/app/api/type"

/** 최근 리포트 조회 기록 목록 */
export const useReportHistoryQuery = (limit = 20) => {
  return useQueryHook<ReportHistoryEntry[], unknown>({
    queryKey: ["readReportHistory", limit],
    queryFn: () => readReportHistory(limit),
    options: {} as UseQueryOptions<ReportHistoryEntry[], ApiError>,
  })
}

/** 리포트 조회 기록 생성 (mutation) */
export const useCreateReportHistoryMutation = () => {
  return useMutationHook(
    (payload: CreateReportHistoryPayload) => createReportHistory(payload),
    [["readReportHistory"]],
  )
}
